module.exports = __webpack_public_path__ + "img/auto.a5e976e2.svg";